import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import BrandShine from '../../../components/BrandShine';
import Brand from "../../../assets/MoneyOverMind/Brand.png";
import Brand3 from "../../../assets/MoneyOverMind/Brand3.png";
import Brand4 from "../../../assets/MoneyOverMind/Brand4.png";
import Brand5 from "../../../assets/MoneyOverMind/Brand5.png";
import Brand6 from "../../../assets/MoneyOverMind/Brand6.png";
import Brand7 from "../../../assets/MoneyOverMind/Brand7.png";
import Brand8 from "../../../assets/MoneyOverMind/Brand8.png";
import TestimonialImage from "../../../assets/MoneyOverMind/Tremaine-Headshot.png"; 
import { Helmet } from "react-helmet";

function MoneyOnMind() {

<Helmet>
  <title>Money On Mind Brand Design Project | Woaom Web Design</title>
  <meta
    name="description"
    content="See the Money On Mind project — a custom branding, website, and digital strategy created for a money mindset coach. Built to empower women entrepreneurs in cities like Atlanta, Houston, New York City, and beyond."
  />
  <meta
    name="keywords"
    content="Money On Mind project, money mindset coach website, women entrepreneurs brand design, financial wellness branding, web design for money coaches, money coach website portfolio, money and mindset custom site, wealth coaching brand visuals, personal finance coach website, financial empowerment branding, women-owned business website design Baltimore, women entrepreneur websites Augusta GA, New Orleans money coach web design, Macon GA women-led brand design, Baton Rouge LA mindset coach websites, Shreveport LA financial wellness websites, Atlanta GA custom websites for coaches, Houston TX women entrepreneurs websites, Austin TX coaching brand design, Dallas TX personal finance website design, New York City women-led business websites, Washington DC women entrepreneur branding, Philadelphia PA coaching website design, Memphis TN women entrepreneurs web design, scalable websites for money coaches, high-converting coaching websites, custom financial coaching sites, brand-forward web design for women, wealth-focused website design"
  />
</Helmet>


  return (
    <section className="bg-white">
      <Navbar />

      {/* Hero Image Section */}
      <div className="mx-auto max-w-8xl ">
        <img
          src={Brand}
          alt="client portal template, notion-style client dashboard, CRM for coaches, portal for 1:1 clients, private course dashboard, membership site template, custom dashboard for online business, onboarding portal for clients, student dashboard template, dashboard for course creators"
          className="inline-block w-full object-cover"
        />
      </div>

      {/* Project Section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Sidebar */}
          <div className="space-y-8">
            <div>
              <h3 className="text-lg font-semibold tracking-widest text-gray-800 uppercase">Services</h3>
              <p className="text-gray-700 mt-2">Brand Design + Web Design</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold tracking-widest text-gray-800 uppercase">Platform</h3>
              <p className="text-orange-500 mt-2">Wix + Figma</p>
            </div>
          </div>

          {/* Project Content */}
          <div className="md:col-span-2 space-y-6">
            <h2 className="text-4xl  font-medium text-gray-900">
              MIND OVER MONEY
            </h2>
            <h4 className="text-xl font-medium text-gray-700">
              Luxe Branding And WordPress Website Design For A Financial Literacy Coach
            </h4>
            <p className="text-gray-800 leading-relaxed">
              Mind Over Money helps Black women take charge of their finances and create realistic plans for early retirement. Tremaine had been operating a successful business with no real branding and a DIY website. She needed custom visuals that represented luxe wealthy lifestyles for black women.
            </p>
            <p className="font-semibold text-sm text-black">
              LIVE SITE:{' '}
              <a
                href="https://mindovermoney.net"
                className="text-orange-600 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                MindOverMoney.net
              </a>
            </p>
          </div>
        </div>

        {/* Testimonial Section */}
        <div className="mt-16 bg-[#f1f6f7] px-6 py-12 rounded-md max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 text-left">
            {/* Circular Image */}
            <div className="flex-shrink-0">
              <img
                src={TestimonialImage}
                alt="e-commerce funnel template, shopify sales funnel, digital product sales page, 
digital product template, Gumroad product page template, lead magnet funnel for coaches, React product landing page, passive income website template, stripe checkout website, course sales funnel"
                className="w-40 h-40 object-cover rounded-full mt-10"
              />
            </div>
            {/* Quote */}
            <div className="flex-1">
              <div className="text-4xl text-[#3d7b75] mb-4">“</div>
              <p className="text-gray-800 text-xl font-light leading-relaxed">
                My metrics have improved by 3,000% and Tiera made this possible. I recently did a pitch competition and one of the judges could tell who my audience was just from my colors, textures and fonts. That’s the level of detail that you’re missing to take your brand to the next level. You cannot DIY 3,000% increase. Hire Tiera.
              </p>
              <p className="mt-6 text-[#3d7b75] uppercase tracking-wide text-sm">– Tremaine</p>
            </div>
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="bg-white space-y-12 pb-20">
        {[Brand3, Brand4, Brand5, Brand6, Brand7, Brand8].map((img, i) => (
          <div key={i} className="mx-auto max-w-8xl">
            <img src={img} alt={`Gallery Image ${i + 1}`} className="w-full object-cover" />
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <BrandShine />

      <Footer />
    </section>
  );
}

export default MoneyOnMind;
